import moment from 'moment'

import styles from './Post.module.scss'
import {
  getFileFullPath,
  getQueryParameterByName,
  isLinkForVideo,
} from '../../../utils/Helpers'
import { connect } from 'react-redux'
import { useEffect } from 'react'
import ReadMore from './ReadMore/ReadMore'
import SocialMediaFooter from '../../Advertisement/SocialMediaFooter/SocialMediaFooter'
import ImageGallery from 'react-image-gallery'
import SharePostFooter from '../../Advertisement/SharePostFooter/SharePostFooter'

const readMoreOrientation = {
  'Covid-19 informacije': 'vertical',
  'Najbolje iz Crne Gore': 'horizontal',
  'Život i stil': 'horizontal',
  'Kalendar zdravlja': 'horizontal',
  'Crnom Gorom': 'horizontal',
  'Glavni grad': 'vertical',
  Dijaspora: 'horizontal',
}

const Post = ({ post, selectedCategory, selectedSubCategory }) => {
  useEffect(() => {
    const s = document.createElement('script')
    s.setAttribute('src', 'https://platform.twitter.com/widgets.js')
    s.setAttribute('async', 'true')
    document.head.appendChild(s)
  }, [])

  useEffect(() => {
    const s = document.createElement('script')
    s.setAttribute('src', 'https://www.instagram.com/embed.js')
    s.setAttribute('async', 'true')
    document.head.appendChild(s)
  }, [])

  const isAdminMainAuthor = post.author === 'dnevno.me'
  const photoGallery =
    Boolean(post.photo_gallery && post.photo_gallery.length) &&
    post.photo_gallery.map((photoLink) => ({
      original: getFileFullPath(photoLink),
      thumbnail: getFileFullPath(photoLink),
    }))

  return (
    <div className={`${styles.post} bg-white`}>
      <p className={`${styles.categoryInfo} uppercase flex items-center`}>
        {selectedCategory ? (
          <span
            className={`${styles.category} px-10 py-1 text-white tracking-normal`}
          >
            {selectedCategory.name}
          </span>
        ) : null}
        {selectedSubCategory ? (
          <span
            className={`${styles.subCategory} px-10 py-1 text-white tracking-normal`}
          >
            {selectedSubCategory.name}
          </span>
        ) : null}
      </p>
      <div className={`${styles.header} pb-5 px-2.5 lg:px-0 mt-2.5`}>
        <div className="flex pb-2.5 pr-2.5">
          <p className={`${styles.subtitle} leading-5 tracking-normal`}>
            {post.subtitle}
          </p>
        </div>
        <h3
          className={`${styles.title} font-bold leading-tight tracking-normal`}
        >
          {post.name}
        </h3>
      </div>
      <div className="flex border-b border-black pb-1 px-2.5 lg:px-0">
        {post.author && (
          <p className={`${styles.info} w-3/6`}>
            <span>Autor: </span>
            <span className="mr-5">
              {isAdminMainAuthor && post?.co_author ? '' : post.author}
              {post?.co_author
                ? (isAdminMainAuthor ? '' : ',  ') + post.co_author
                : ''}
            </span>
            <br />
            {post.news_source && <span> Izvor: {post.news_source} </span>}
          </p>
        )}
        <div className={`${styles.createdAt} text-right w-3/6 mb-2.5`}>
          <p>
            {/*<span className="mr-0 lg:mr-2">Vrijeme objave:</span>*/}
            {/*<br className="block lg:hidden" />*/}
            <span>
              {post.published_at
                ? `${moment(post.published_at).format('DD.MM.YYYY HH:mm')}h`
                : null}
            </span>
          </p>
          {moment(post.updated_at).diff(moment(post.created_at), 'minutes') >
            2 && (
            <p>
              {/*<span className="mr-0 lg:mr-2">Vrijeme ažuriranja:</span>*/}
              {/*<br className="block lg:hidden" />*/}
              <span>
                {post.published_at
                  ? `${moment(post.updated_at).format('DD.MM.YYYY HH:mm')}h`
                  : null}
              </span>
            </p>
          )}
        </div>
      </div>
      <div className={`${styles.postWrapper} mt-8`}>
        {post.featured_in_post === 1 && (
          <div className="mb-4">
            {isLinkForVideo(post.featured_image) ? (
              <video
                autoPlay
                muted
                controls
                src={getFileFullPath(post.featured_image)}
              >
                Your browser does not support videos.
              </video>
            ) : (
              <img src={getFileFullPath(post.featured_image)} />
            )}
            {post.featured_legend && (
              <p className={styles.featuredLegend}>{post.featured_legend}</p>
            )}
          </div>
        )}

        <div
          dangerouslySetInnerHTML={{
            __html: post.content
              ? post.content +
                (post.video
                  ? `<iframe
                      className="w-full"
                      height="400"
                      src="https://www.youtube.com/embed/${getQueryParameterByName(
                        'v',
                        post.video
                      )}"
                      frameBorder="0"
                      allow="autoplay"
                    />`
                  : '')
              : `<iframe
                    className="w-full"
                    height="400"
                    src="https://www.youtube.com/embed/${getQueryParameterByName(
                      'v',
                      post.video
                    )}"
                    frameBorder="0"
                    allow="autoplay"
              />`,
          }}
        />
      </div>

      {readMoreOrientation[selectedCategory.name] && (
        <ReadMore
          currentPostSlug={post.slug}
          categoryId={selectedCategory.id}
          categoryName={selectedCategory.name}
          orientation={readMoreOrientation[selectedCategory.name]}
        />
      )}

      {photoGallery && <ImageGallery items={photoGallery} />}

      <SharePostFooter post={post} />
      <SocialMediaFooter />

      {/*<div className="block md:hidden">*/}
      {/*  <MostReadFeed />*/}
      {/*</div>*/}
    </div>
  )
}

const mapStateToProps = (state) => ({
  selectedCategory: state.selectedCategory,
  selectedSubCategory: state.selectedSubCategory,
})

export default connect(mapStateToProps)(Post)
